import {RefCounted} from "neuroglancer/util/disposable";
import {viewer} from "../main";
import {quat} from "neuroglancer/util/geom";
import {ManagedUserLayer} from "neuroglancer/layer";

export class UmapMamager extends RefCounted {
  umapEnable: boolean = false;
  positionStorage: Float32Array | undefined;
  zoomStorage: number | undefined;
  orientationStorage: quat | undefined;
  storageVisibleImage: Set<string> = new Set();

  setViewerPose(layer:ManagedUserLayer){

    const viewportRect= viewer.display.orderedPanels[0].element.getBoundingClientRect()
    const umapUpperBounds = layer?.localPosition.coordinateSpace.value.boundingBoxes[0]?.box.upperBounds??[0,0]
    const umapLowerBounds = layer?.localPosition.coordinateSpace.value.boundingBoxes[0]?.box.lowerBounds??[0,0]
    const umapWidth = umapUpperBounds[0] - umapLowerBounds[0];
    const umapHeight = umapUpperBounds[1] - umapLowerBounds[1];
    const umapCenterX = (umapUpperBounds[0] + umapLowerBounds[0]) * 0.5;
    const umapCenterY = (umapUpperBounds[1] + umapLowerBounds[1]) * 0.5;
    const scale = Math.max(umapWidth/viewportRect.width,umapHeight/viewportRect.height) * 1.2

    viewer.navigationState.zoomFactor.value = scale;
    let position = viewer.navigationState.position.value;
    position[0] = umapCenterX;
    position[1] = umapCenterY;
    viewer.navigationState.position.value = position;
    viewer.navigationState.pose.orientation.reset();
  }
  enableUmap(enableFlag: boolean = false, saveStatus: boolean = false, layer:ManagedUserLayer | undefined = undefined) {
    this.umapEnable = enableFlag;
    // const imageLayerScrollDom = document.querySelector('.image_layer-scroll.image_layer');//禁用图像图层显隐操作
    const binsize_auto = document.getElementsByClassName('binsize-auto-control')[0] as HTMLElement;
    const navigatorWidget = document.getElementsByClassName('neuroglancer-navigator-widget')[0] as HTMLElement;
    if (enableFlag) {
      if (saveStatus) {
        this.saveUmapPreStatus();
      }
      binsize_auto?.classList.add('ng-common-disabled');
      navigatorWidget?.classList.add('umap-hide');
      // imageLayerScrollDom?.classList.add('umap-disble');
      layer && this.setViewerPose(layer);
    } else {
      this.loadPreStatus();
      binsize_auto?.classList.remove('ng-common-disabled');
      navigatorWidget?.classList.remove('umap-hide');
      // imageLayerScrollDom?.classList.remove('umap-disble');
    }
  }
  saveUmapPreStatus(){
    // const {layerManager: {managedLayers: managedLayers}} = viewer
    // managedLayers.forEach((item) => {
    //   if (item.type === 'image' && item.visible) {
    //     item.visible = false;
    //     this.storageVisibleImage.add(item.name);
    //   }
    // })
    this.zoomStorage = viewer.navigationState.zoomFactor.value;
    this.positionStorage = new Float32Array(viewer.navigationState.position.value);
    this.orientationStorage = new Float32Array(viewer.navigationState.pose.orientation.orientation) as quat;
  }
  loadPreStatus(){
    const {layerManager: {managedLayers: managedLayers}} = viewer
    managedLayers.forEach((item) => {
      if (item.type === 'image' && this.storageVisibleImage.has(item.name)) {
        item.visible = true;
      }
    })
    this.storageVisibleImage.clear();
    setTimeout(()=>{
      if(this.zoomStorage) viewer.navigationState.zoomFactor.value = this.zoomStorage;
      if(this.positionStorage) viewer.navigationState.position.value = this.positionStorage;
      if(this.orientationStorage) viewer.navigationState.pose.orientation.orientation = this.orientationStorage;
      viewer.navigationState.pose.orientation.changed.dispatch();
    },100)
  }
  updateUmapView(){
    const visibleUmap = viewer.layerManager.managedLayers.find((item:any) => {
      return (item.name.includes('UMAP') && item.visible);
    })
    this.enableUmap(Boolean(visibleUmap));
  }
}
